'use strict';

angular.module('ClinicApp').controller('ModalOCSEligibilityCtrl', function($scope, $window, $modalInstance, clinic, showBackButton, CurrentUser, ClinicService, PracticeManagementSoftwareConstants, OCEligiblePMS) {
  $scope.clinic = clinic;
  $scope.showBackButton = showBackButton;

  $scope.OCEligiblePMS = OCEligiblePMS.map(({
    name,
  }) => name);
  $scope.managementSoftware = PracticeManagementSoftwareConstants;

  $scope.userSelected = {};
  $scope.isCompatible = null;
  $scope.pms = _.get(clinic, 'metadata.practiceManagementSoftware.name');
  $scope.optionLabel = $scope.pms ? $scope.pms : '--- Software ---';

  $scope.setTextAndLink = function(condition) {
    if (condition) {
      $scope.link = 'https://calendly.com/opencareocs-zedrick/opencareprosetup';
      $scope.resultsText = 'Your PMS software can be connected to Opencare. Receive more patients and improve appointment scheduling today.';
      $scope.ctaText = 'Connect my PMS';
    } else {
      $scope.link = 'https://calendly.com/customerenablement/opencarepro-learnmore';
      $scope.resultsText = 'Unfortunately, your PMS software cannot be connected to Opencare. But you can still get more patients and improve appointment scheduling by manually adding slots. Schedule a call with our support team to learn more today!';
      $scope.ctaText = 'I want to learn more!';
    }
  };

  $scope.setTextAndLink($scope.OCEligiblePMS.includes($scope.pms));

  $scope.onSoftwareSelect = function() {
    $scope.isCompatible = $scope.OCEligiblePMS.includes(
      $scope.userSelected.software.name,
    );

    $scope.setTextAndLink($scope.isCompatible);

    $scope.userSelected.softwareOther = null;
    $scope.optionLabel = '--- Software ---';
  };

  $scope.save = function() {
    ClinicService.updateClinic($scope.clinic, {
      metadata: {
        practiceManagementSoftware: {
          name: $scope.userSelected.softwareOther || $scope.userSelected.software?.name,
        },
        ocsCompatibility: $scope.isCompatible,
      },
    });
  };

  OpencareAnalytics.trackPageView({
    pageType: OpencareAnalytics.pageTypes.OPENCARE_HOURS_MANAGER,
    pageName: clinic.name,
    name: 'opencare-eligibility-manager',
    practiceId: clinic.id,
    content: {
      is_real_practice: String(!CurrentUser.isImpersonated()),
    },
  });

  $scope.back = function() {
    $window.history.back();
    $modalInstance.dismiss('cancel');
  };

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };
});
